import React, { PureComponent } from 'react';
import Typography from '@nubank/nuds-web/components/Typography/Typography';

import Block from 'components/structure/Block/Block';

import { StyledSection } from './styles/StyledSection';

class SectionTransparency extends PureComponent {
  render() {
    return (
      <StyledSection
        backgroundColor="#312732"
        backgroundImageUrl={{
          xs: 'group-man-building/group-man-building@0.5x.jpg',
          sm: 'group-man-building/group-man-building@0.75x.jpg',
          md: 'group-man-building/group-man-building@3x.jpg',
        }}
      >
        <Block>
          <Typography
            variant="title"
            color="white"
            colorVariant="default"
            gutterBottom={2}
            intlKey="LENDING.TRANSPARENCY.TITLE"
            intlValues={{ br: <br /> }}
          />
          <Typography
            variant="paragraph2"
            color="white"
            colorVariant="default"
            intlKey="LENDING.TRANSPARENCY.DESCRIPTION"
          />
        </Block>
      </StyledSection>
    );
  }
}

export default SectionTransparency;
